import React from "react";
import {css} from "@panda/css";

import {InfoIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {investmentOffer, numberFormat, propertyOffer} from "@pg-mono/string-utils";

import {Heading} from "../../../atoms/Heading";
import {MULTI_REGION_HEADER_LIMIT} from "../../constants/multi_region_header_limit";
import {ISelectedRegion} from "../../list/actions/offer_list_selected_data_actions";
import {OfferListPromotionLink} from "../../list/components/OfferListPromotionLink";
import {useOfferListingMapHeaderData} from "../hooks/use_offer_listing_map_header";

interface IProps {
    pageTitle: string;
    propertiesCount: number | null;
    offerCount: number;
    selectedRegion: ISelectedRegion[];
    generatedDescriptionAllowed: boolean;
    onShowGeneratedDescription: () => void;
    onHeaderClick?: () => void;
}

interface IMapHeaderTitleProps {
    onClick?: React.MouseEventHandler;
}

const MapHeaderTitle = (props: IMapHeaderTitleProps) => {
    const {searchPhrase, regionName, regionsOverLimitCount} = useOfferListingMapHeaderData({multiRegionLimit: MULTI_REGION_HEADER_LIMIT});

    const multiRegionInfo =
        regionsOverLimitCount > 0 ? (
            <Text as="span" variant="body_copy_2" className={regionOverLimitTextWrapper}>
                {`+${regionsOverLimitCount}`}
            </Text>
        ) : null;

    return (
        <Text as="h1" mb={1} variant="headline_6" onClick={props.onClick}>
            Mapa inwestycji <Highlight>{regionName}</Highlight> {multiRegionInfo} - {searchPhrase}
        </Text>
    );
};

export const MapHeader = React.memo((props: IProps) => {
    const {propertiesCount, offerCount, generatedDescriptionAllowed, onShowGeneratedDescription} = props;

    const promotionsCount = props.selectedRegion.length === 1 && props.selectedRegion[0].stats ? props.selectedRegion[0].stats.promotions_count_total : 0;
    // Minimum promotions number needed to display link - business requirement
    const showPromotionsLink = !!promotionsCount && promotionsCount > 5;

    return (
        <div className={headingWrapper}>
            {generatedDescriptionAllowed && <InfoIcon className={info} onClick={onShowGeneratedDescription} size="2.4" />}

            <Heading type="div" padding="0">
                <MapHeaderTitle onClick={props.onHeaderClick} />
                {propertiesCount != null && (
                    <Text as="div" color="var(--colors-gray-700)" variant="info_txt_1">
                        {numberFormat(propertiesCount)} {propertyOffer.nominative(propertiesCount)} w {numberFormat(offerCount)}{" "}
                        {investmentOffer.locative(offerCount)}
                        {showPromotionsLink && <OfferListPromotionLink selectedRegion={props.selectedRegion} className={linkStyle} />}
                    </Text>
                )}
            </Heading>
        </div>
    );
});

export const headingWrapper = css({
    gap: 1,
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",

    md: {
        minWidth: "57.3rem",
        width: "42%",
        minHeight: "10.2rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        position: "absolute",
        top: 0,
        right: 0,
        backgroundColor: "var(--colors-gray-100)",
        padding: "2rem"
    }
});

const info = css({
    position: "absolute",
    right: 2,
    cursor: "pointer",
    top: 8
});

const linkStyle = css({
    textDecoration: "underline",
    color: "var(--colors-gray-700)",

    md: {
        textDecoration: "none",
        color: "var(--colors-secondary)"
    }
});

const regionOverLimitTextWrapper = css({
    marginRight: 0.5,
    borderRadius: 3,
    display: "inline-flex",
    justifyContent: "center",
    verticalAlign: "middle",
    alignItems: "center",
    minWidth: 3.5,
    height: 3.5,
    background: "var(--colors-primary)",
    cursor: "pointer"
});
import React from "react";
import {css} from "@panda/css";

import {InfoIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {investmentOffer, numberFormat, propertyOffer} from "@pg-mono/string-utils";

import {Heading} from "../../../atoms/Heading";
import {MULTI_REGION_HEADER_LIMIT} from "../../constants/multi_region_header_limit";
import {ISelectedRegion} from "../../list/actions/offer_list_selected_data_actions";
import {OfferListPromotionLink} from "../../list/components/OfferListPromotionLink";
import {useOfferListingMapHeaderData} from "../hooks/use_offer_listing_map_header";

interface IProps {
    pageTitle: string;
    propertiesCount: number | null;
    offerCount: number;
    selectedRegion: ISelectedRegion[];
    generatedDescriptionAllowed: boolean;
    onShowGeneratedDescription: () => void;
    onHeaderClick?: () => void;
}

interface IMapHeaderTitleProps {
    onClick?: React.MouseEventHandler;
}

const MapHeaderTitle = (props: IMapHeaderTitleProps) => {
    const {searchPhrase, regionName, regionsOverLimitCount} = useOfferListingMapHeaderData({multiRegionLimit: MULTI_REGION_HEADER_LIMIT});

    const multiRegionInfo =
        regionsOverLimitCount > 0 ? (
            <Text as="span" variant="body_copy_2" className={regionOverLimitTextWrapper}>
                {`+${regionsOverLimitCount}`}
            </Text>
        ) : null;

    return (
        <Text as="h1" mb={1} variant="headline_6" onClick={props.onClick}>
            Mapa inwestycji <Highlight>{regionName}</Highlight> {multiRegionInfo} - {searchPhrase}
        </Text>
    );
};

export const MapHeader = React.memo((props: IProps) => {
    const {propertiesCount, offerCount, generatedDescriptionAllowed, onShowGeneratedDescription} = props;

    const promotionsCount = props.selectedRegion.length === 1 && props.selectedRegion[0].stats ? props.selectedRegion[0].stats.promotions_count_total : 0;
    // Minimum promotions number needed to display link - business requirement
    const showPromotionsLink = !!promotionsCount && promotionsCount > 5;

    return (
        <div className={headingWrapper}>
            {generatedDescriptionAllowed && <InfoIcon className={info} onClick={onShowGeneratedDescription} size="2.4" />}

            <Heading type="div" padding="0">
                <MapHeaderTitle onClick={props.onHeaderClick} />
                {propertiesCount != null && (
                    <Text as="div" color="var(--colors-gray-700)" variant="info_txt_1">
                        {numberFormat(propertiesCount)} {propertyOffer.nominative(propertiesCount)} w {numberFormat(offerCount)}{" "}
                        {investmentOffer.locative(offerCount)}
                        {showPromotionsLink && <OfferListPromotionLink selectedRegion={props.selectedRegion} className={linkStyle} />}
                    </Text>
                )}
            </Heading>
        </div>
    );
});

export const headingWrapper = css({
    gap: 1,
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",

    md: {
        minWidth: "57.3rem",
        width: "42%",
        minHeight: "10.2rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        position: "absolute",
        top: 0,
        right: 0,
        backgroundColor: "var(--colors-gray-100)",
        padding: "2rem"
    }
});

const info = css({
    position: "absolute",
    right: 2,
    cursor: "pointer",
    top: 8
});

const linkStyle = css({
    textDecoration: "underline",
    color: "var(--colors-gray-700)",

    md: {
        textDecoration: "none",
        color: "var(--colors-secondary)"
    }
});

const regionOverLimitTextWrapper = css({
    marginRight: 0.5,
    borderRadius: 3,
    display: "inline-flex",
    justifyContent: "center",
    verticalAlign: "middle",
    alignItems: "center",
    minWidth: 3.5,
    height: 3.5,
    background: "var(--colors-primary)",
    cursor: "pointer"
});
